export const categoryModel = {
  categoryName: "",
  description: "",
};
